import type { SocialAuthTypes } from '@patrianna/shared-patrianna-types/store/AuthModule'
import { facebookAuth as facebookAuthAction } from '@patrianna/shared-store/auth/store/facebookActions'

import { FACEBOOK_APP_ID } from 'config/apps'
import type { TypedThunk } from 'src/store/types'
import { LS_AUTH_TYPE, setDataToLocalStorage } from 'src/utils/localStorage'

export const facebookAuth =
  (authType: SocialAuthTypes): TypedThunk =>
  (dispatch) => {
    dispatch(setDataToLocalStorage(LS_AUTH_TYPE, authType, false))
    dispatch(facebookAuthAction({ authType, facebookAppId: FACEBOOK_APP_ID }))
  }
